module.exports = __webpack_public_path__ + "static/media/12UNCTAD16.8dd2d575.jpg";